module.exports = __webpack_public_path__ + "static/MicroFrontends Logo 2-819b01c6ce19617c9e4c89ec3425e19e.png";